import * as React from 'react';
import BootstrapTable from 'react-bootstrap-table-next';
import overlayFactory from 'react-bootstrap-table2-overlay';
import paginationFactory from 'react-bootstrap-table2-paginator';

import {RouteComponentProps} from 'react-router';
import {Debounce} from 'react-throttle';
import moment from 'moment-timezone';

interface IEventsRouterProps {
	type: string;
}

interface IEventsDispatchProps {
	any?: any
}

interface IColumnsMap {
	dataField: string;
	text: string;
	sort?: boolean;
	formatter?: (cell, row, rowIndex, formatExtraData) => any;
}

interface IColumns {
	[key: string]: IColumnsMap[]
}

interface IEventsProps extends RouteComponentProps<IEventsRouterProps> {
	any?: any
}

const SystemsTable = ({loading, data, page, sizePerPage, onTableChange, totalSize, type}) => (
	<div>
		<BootstrapTable
			remote={true}
			loading={loading}
			keyField="id"
			data={data}
			columns={eventColumnMap[type]}
			pagination={paginationFactory({page, sizePerPage, totalSize})}
			onTableChange={onTableChange}
			overlay={overlayFactory({spinner: true, background: 'rgba(192,192,192,0.3)'})}
			noDataIndication="No events"
			hover={true}
		/>
	</div>
);

const EventsTable = ({loading, data, page, sizePerPage, onTableChange, totalSize, type}) => (
	<div>
		<BootstrapTable
			remote={true}
			loading={loading}
			keyField="id"
			data={data}
			columns={eventColumnMap.EDDN}
			pagination={paginationFactory({page, sizePerPage, totalSize})}
			onTableChange={onTableChange}
			overlay={overlayFactory({spinner: true, background: 'rgba(192,192,192,0.3)'})}
			noDataIndication="No events"
			hover={true}
		/>
	</div>
);

const factionFormatter = (cell, row): any => {
	// console.log(row);
	let returnString = '';
	console.log(row);
	for (const i of row.FactionEffects) {
		console.log(i);
		if (!i.Faction.trim()) {
			continue;
		}
		returnString += `${i.Faction}:\n `;
		for (const inf of i.Influence) {
			console.log(inf);
			returnString += `${inf.Trend}\n`;
		}
	}
	return (
		returnString
	)
};
const tzFormatter = (cell): any => moment(cell).toISOString(true);

const RedeemVoucherFactionFormatter = (cell, row): any => {
	let returnString = '';
	if (!row.Factions) {
		return <span> {cell} </span>
	}
	for (const i of row.Factions) {
		returnString += `${i.Faction}: ${i.Amount}CR, `;
	}
	return (
		<span>{returnString}</span>
	)
};
const eventColumnMap: IColumns = {
	Default: [
		{dataField: 'StarSystem', text: 'System', sort: true},
		{dataField: 'DateAdded', text: 'Date Added', sort: true, formatter: tzFormatter}
	],
	EDDN: [
		{dataField: 'message.StarSystem', text: 'System', sort: true},
		{dataField: 'message.event', text: 'Event', sort: true},
		{dataField: 'message.StationName', text: 'Station', sort: true},
		{dataField: 'message.timestamp', text: 'Timestamp', sort: true, formatter: tzFormatter}
	]
};

export default class EDDN extends React.Component<IEventsProps & IEventsDispatchProps> {
	public allowedEvents: string[] = Object.keys(eventColumnMap);

	public state: { events: any[]; systemFilter: string; type: string; hasEvents: boolean, page: number, sizePerPage: number, totalSize: number, loading: boolean, trackedSystem: string; trackedSystems: any[]; eventsPage: number; eventSizePerPage: number; eventTotalSize: number } = {
		events: [],
		trackedSystems: [],
		hasEvents: false,
		loading: false,
		page: 1,
		sizePerPage: 25,
		eventSizePerPage: 25,
		eventsPage: 1,
		totalSize: 0,
		eventTotalSize: 0,
		systemFilter: '',
		trackedSystem: '',
		type: 'Default'
	};

	constructor(props: IEventsProps & IEventsDispatchProps) {
		super(props);
		this.state.type = props.match.params.type || 'Default'
	}
	public AddTrackedChangeHandler = (e: React.ChangeEvent<any>) => {
		this.setState({
			trackedSystem: e.target.value
		}, async () => {
			await this.FetchTrackedSystems(0);
		});
	};
	public handleSystemsChange = async (type, {page, sizePerPage}) => {
		const currentIndex = (page - 1) * sizePerPage;
		this.setState(() => ({loading: true}));
		await this.FetchTrackedSystems(currentIndex);
		this.setState({
			page,
			sizePerPage
		});
	};

	public handleEventsChange = async (type, {page, sizePerPage}) => {
		const currentIndex = (page - 1) * sizePerPage;
		this.setState(() => ({eventsLoading: true}));
		await this.getEvents(currentIndex);
		this.setState({
			eventsPage: page,
			eventSizePerPage: sizePerPage
		});
	};

	public FilterSystems = (e: any) => {
		return this.setState({systemFilter: e.target.value}, () => {
			return this.getEvents(0);
		});
	};

	public selectType() {
		return (
			<div className={'form-group'}>
				<label>System</label>
				<Debounce time="400" handler="onChange">
					<input className={'form-control'} onChange={this.AddTrackedChangeHandler}/>
				</Debounce>
				<button className="btn btn-default" onClick={this.AddOrRemoveTrackedSystem} id="add">Add</button>
				<button className="btn btn-default" onClick={this.AddOrRemoveTrackedSystem} id="remove">Remove</button>
				<button className="btn btn-default" onClick={this.FilterSystems} id="filter">Filter</button>
			</div>
		)
	}

	public getColumns() {
		const list = [];
		for (let i = 0; i <= this.state.events.length; i++) {
			if (!this.state.events[i] || !this.state.events[i].message) {
				continue;
			}
			for (const key in this.state.events[i].message || {}) {
				if (list.indexOf({
					dataField: `message.${key}`,
					text: key
				}) === -1 && typeof this.state.events[i].message[key] !== 'object') {
					list.push({dataField: `message.${key}`, text: key});
				}
			}
		}
		return list
	}

	public getEvents(skip: number) {
		return fetch(`/api/eddn/events?skip=${skip}${this.state.trackedSystem ? `&system=${this.state.trackedSystem}` : ''}`, {
			credentials: 'include'
		})
			.then(res => res.json())
			.then(events => {
				return this.setState({events: events.docs, eventTotalSize: events.total});
			})
			.catch(err => {
				console.error(err);
			})
	}

	public render() {
		return (
			<div>
				<h1>EDDN Events</h1>
				{this.selectType()}
				{this.state.trackedSystems && this.state.trackedSystems.length >= 0 ?
					<SystemsTable
						loading={this.state.loading}
						data={this.state.trackedSystems}
						page={this.state.page}
						sizePerPage={this.state.sizePerPage}
						onTableChange={this.handleSystemsChange}
						totalSize={this.state.totalSize}
						type={this.state.type}
					/>
					: <div>Loading</div>}

				{this.state.events && this.state.events.length >= 0 ?
					<EventsTable
						loading={this.state.loading}
						data={this.state.events}
						page={this.state.eventsPage}
						sizePerPage={this.state.eventSizePerPage}
						onTableChange={this.handleEventsChange}
						totalSize={this.state.eventTotalSize}
						type={this.state.type}
					/>
					: <div>Loading</div>}
			</div>
		)
	}

	public FetchTrackedSystems = (skip) => {
		return fetch(`/api/eddn/list?skip=${skip}`, {
			credentials: 'include'
		})
			.then((res) => res.json())
			.then(events => {
				return this.setState({
					trackedSystems: events.tracked,
					totalSize: events.total,
					hasEvents: true,
					loading: false
				});
			})
			.catch((err) => {
				throw err;
			});
	};

	public AddOrRemoveTrackedSystem = (e: any) => {
		return fetch(`/api/eddn/${e.target.id}`, {
			body: JSON.stringify({StarSystem: this.state.trackedSystem}),
			credentials: 'include',
			headers: {
				'Accept': 'application/json',
				'Content-Type': 'application/json'
			},
			method: 'POST'
		})
			.then((res) => res.json())
			.then(() => {
				return this.FetchTrackedSystems(0)
			})
			.catch((err) => {
				console.error(err);
			});
	};

	public async componentDidMount() {
		if (!this.state.type) {
			this.setState({hasEvents: false});
			this.selectType();
			return
		}
		await this.FetchTrackedSystems(0);
		await this.getEvents(0);
	}
};



// WEBPACK FOOTER //
// ./src/EDDN.tsx